import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import type { BlogListItem } from '../../shared/models/blog.models';
import { MarketingBlogCardComponent } from './marketing-blog-card.component';

@Component({
  selector: 'app-marketing-blog-country-strip',
  standalone: true,
  imports: [RouterLink, MarketingBlogCardComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (posts.length) {
      <section class="cg-blog-country-strip cg-mkt-section cg-section">
        <div class="cg-container--marketing">
          <div class="cg-blog-country-strip__head">
            <h2 class="cg-blog-country-strip__title">Related Articles</h2>
            @if (countrySlug) {
              <a [routerLink]="['/blogs/country', countrySlug]" class="cg-mkt-btn cg-mkt-btn--ghost">View all</a>
            }
          </div>
          <div class="cg-blog-grid cg-blog-grid--compact">
            @for (post of posts; track post.slug) {
              <app-marketing-blog-card [post]="post" />
            }
          </div>
        </div>
      </section>
    }
  `,
})
export class MarketingBlogCountryStripComponent {
  @Input() posts: BlogListItem[] = [];
  @Input() countrySlug = '';
}
